module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-chapter-hero-4aeba0edcc911c667822697571ddbd6b.svg";